import { render, staticRenderFns } from "./EventsArchivePage.vue?vue&type=template&id=90c2faa8&scoped=true"
import script from "./EventsArchivePage.vue?vue&type=script&lang=js"
export * from "./EventsArchivePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c2faa8",
  null
  
)

export default component.exports